import { pageModule } from '@components/pageModule';
import { createPlatformView } from '@packages/platform';
import { createUserViews } from '@packages/user';

const Default = () => pageModule(import('./Default'));

export const SidebarItems = createPlatformView({
    default: createUserViews({
        default: Default,
    }),
});
